import appSettings from '@/appSettings'

// N'afficher l'onglet Agenda que là où AtAgenda est réellement déployé/configuré pour
// l'environnement courant (getAtagendaURL() non vide). Aujourd'hui : DEV uniquement.
// Le jour où AtAgenda est déployé en staging/prod, il suffira d'y renseigner
// VUE_APP_ATAGENDA_DOMAIN dans appSettings et l'onglet apparaîtra automatiquement.
// Évite un onglet mort (iframe vers un host inexistant) hors DEV.
export default appSettings.getAtagendaURL()
  ? [
      {
        title: 'Agenda',
        icon: 'CalendarIcon',
        route: 'agenda',
      },
    ]
  : []
